export default {
  seatWireToInt,
  seatIntToWire,
};

function seatWireToInt (wireSeat) {
  if (!wireSeat._attributes) return {};
  const { row, seatnum, FlightSeatID, coordinates, available, ResStatus } = wireSeat._attributes;
  return {
    row: row ? parseInt(row, 10) || '' : 0,
    seatNum: seatnum,
    seatId: FlightSeatID,
    coords: coordinates,
    available: available === 'true' || available === true,
    status: ResStatus,
  };
}

function seatIntToWire (intSeat) {
  const { row, seatNum, seatId, coords, available, status } = intSeat;
  return {
    _row: row,
    _seatnum: seatNum,
    _FlightSeatID: seatId,
    _coordinates: coords,
    _available: available,
    _ResStatus: status,
  };
}



// WEBPACK FOOTER //
// ./src/converter/SeatConverter.js